import { useState } from 'react';

export type DeleteSelection = {
  isSelected: boolean;
  selectedId: Array<string>;
};

const initialState = {
  isSelected: false,
  selectedId: [],
};

const useNotificationDelete = () => {
  const [selected, setSelected] = useState<DeleteSelection>(initialState);

  const clearSelection = () => {
    setSelected(initialState);
  };

  return { selected, setSelected, clearSelection };
};

export default useNotificationDelete;
